import { BASE_URL } from './utils/constants';

export const routes = {
  [BASE_URL]: {
    fetch: () =>
      import(
        /* webpackChunkName: 'reporting-route' */ 'app/reporting/asyncRoute'
      ).then(module => module.default),
  },
};
